import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import BeforeAfter from '../components/BeforeAfter';
import Contact from '../components/Contact';
import PartnersAndSede from '../components/PartnersAndSede';
import Storia from '../components/Storia';
import Team from '../components/Team';
import Mission from '../components/Mission';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';
import CookieBanner from '../components/CookieBanner';
import { useAnalytics } from '../hooks/useAnalytics';

const Home = () => {
  useAnalytics();
  return (
    <div className="min-h-screen bg-white">
      <a href="#main-content" className="skip-link">Vai al contenuto principale</a>
      <Header />
      <main id="main-content">
        <Hero />
        <Services />
        <Testimonials />
        <BeforeAfter />
        <Contact />
        <PartnersAndSede />
        <Storia />
        <Team />
        <Mission />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CookieBanner />
    </div>
  );
};

export default Home;
